import React, { useState } from "react";
import { updateSettlementTimeRecordDto } from "../../service/SettlementTimeRecordRequest";

import {TextField,
    Button, Box, Container, makeStyles,
} from '@material-ui/core';
import {
    SettlementTimeRecordFormBottonControl,
} from './style/SettlementTimeRecordStyle';



const settlementtimerecordStyles = makeStyles({
    field: {
        marginTop: 20,
        marginBottom: 10,

    },
    hidden: {
        display: 'none',
    },
});
export default function SettlementTimeRecordEditForm({handleEditClose, handleEditSubmit, editSettlementTimeRecordDto}) {
    const classes = settlementtimerecordStyles();

    const [id, setId] = useState(editSettlementTimeRecordDto.id);

    const [status, setStatus] = useState(editSettlementTimeRecordDto.status);
    
    const handleSubmitData=(e) =>{
        e.preventDefault();
        console.log('SettlementTimeRecordForm====');
        console.log('status===', status);


        const saveSettlementTimeRecordDto = {
            'id': id,
            'status': status
        };

        updateSettlementTimeRecordDto(saveSettlementTimeRecordDto);

        handleEditSubmit();
    };
    return (
        <div>


            <Container >


                <form noValidate autoComplete="off" onSubmit={handleSubmitData}>


                    <Box>
                        <TextField
                            onChange={((e)=> setStatus(e.target.value))}
                            className={classes.field}
                            id="standard-disabled"
                            label="Status"
                            variant="standard"
                            value={status}

                        />
                    </Box>


                    <SettlementTimeRecordFormBottonControl>
                        <Button type="submit" variant="outlined" className="btn right">Submit</Button>
                        <Button variant ="outlined" onClick={handleEditClose} className="btn right">close</Button>

                    </SettlementTimeRecordFormBottonControl>

                </form>
            </Container>

        </div>
    );
}

